/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ConstructionScheduleRestService, ScheduleTaskType } from '@gh/builder-shared-data';
import { DictionaryService, getRouteQueryParam, InitViewService } from '@gh/common-shared';
import { ID } from '@gh/common-shared-data';
import { GridLayoutService } from '@gh/core-ui-grid';
import { map$ } from '@gh/rx/operators';
import { Observable } from 'rxjs';
import {
  CONSTRUCTION_WORKSHEET_DETAILS_INIT,
  ConstructionWorksheetDetails,
  constructionWorksheetDetailsFromDto,
  constructionWorksheetDetailsToDto,
} from './construction-worksheet.model';

@Injectable()
export class ConstructionWorksheetBusinessService implements InitViewService {
  constructor(private gridLayouts: GridLayoutService,
              private dictionaries: DictionaryService,
              private constructionRest: ConstructionScheduleRestService) {
  }

  initView(route: ActivatedRouteSnapshot): any {
    const scheduleId = getRouteQueryParam(route, 'scheduleId');
    return {
      taskTypeDict: this.dictionaries.getByEnum(ScheduleTaskType),
      gridLayout: this.gridLayouts.get('constructionWorksheet'),
      details: scheduleId ? this.get(scheduleId) : CONSTRUCTION_WORKSHEET_DETAILS_INIT,
    };
  }

  get(scheduleId: ID): Observable<ConstructionWorksheetDetails> {
    return this.constructionRest.getWorksheet(scheduleId).pipe(map$(constructionWorksheetDetailsFromDto));
  }

  update(details: ConstructionWorksheetDetails): Observable<ConstructionWorksheetDetails> {
    return this.constructionRest.updateWorksheet(constructionWorksheetDetailsToDto(details)).pipe(
      map$(constructionWorksheetDetailsFromDto));
  }
}
